// import libs
import { createStore, applyMiddleware, compose } from 'redux';
// import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from 'Redux/reducers';
import api from 'Redux/middleware/';
// import DevTools from '../../config/devTools';


const configureStore = (preloadedState) => {
  const enhacers = compose(
    applyMiddleware(thunk, api),
    // applyMiddleware(thunk, api),
    window.devToolsExtension ? window.devToolsExtension() : (f) => f,
  );

  const store = createStore(
    rootReducer,
    preloadedState,
    enhacers,
  );
  if (module.hot) {
    module.hot.accept('Redux/reducers', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};


export default configureStore;
